import { Card, Chip, Delimiter, Typography, CardHeader, Avatar } from '@otp/ui';
import clsx from 'clsx';
import { StoreModel } from 'src/graphql/generated/graphql';
import styles from './index.module.css';
import { useTranslation } from 'react-i18next';
import { Home } from '@otp/icons';

type RestaurantCardProps = {
  store: Partial<StoreModel>;
};

export const RestaurantCard = ({ store }: RestaurantCardProps) => {
  const { t } = useTranslation();
  return (
    <Card
      className={clsx(
        styles.cardWrapper,
        'w-full bg-white flex flex-col gap-2',
      )}
    >
      <CardHeader
        avatar={
          <Avatar
            sx={{ bgcolor: 'mcdYellow' }}
            aria-label={t('manage-restaurants.home')}
          >
            <Home className={styles.homeColor} />
          </Avatar>
        }
        title={
          <Typography
            component="div"
            variant="subtitle1"
            fontWeight="bold"
            className="flex mb-2 w-100"
          >
            {store.name}
            <div className="ml-auto">
              <Chip label={`#${store.nationalStoreNumber}`} color="primary" />
            </div>
          </Typography>
        }
        subheader={
          <Typography component="div" variant="subtitle2">
            {store.city}, {store.country} <br />
            {store.address1}
          </Typography>
        }
        className="p-0 flex-wrap"
      />
      <Delimiter />
      <div className="flex flex-col	">
        <Typography
          component="div"
          variant="subtitle2"
          className="flex flex-row justify-between"
        >
          <p>{t('manage-restaurants.state-site-id', 'State Site ID')}</p>
          <p>{store.stateSiteId}</p>
        </Typography>
        <Typography
          component="div"
          variant="subtitle2"
          className="flex flex-row justify-between"
        >
          <p>{t('manage-restaurants.organisation', 'Organisation')}</p>
          <p>{store.organization?.name}</p>
        </Typography>
        <Typography
          component="div"
          variant="subtitle2"
          className="flex flex-row justify-between"
        >
          <p>{t('manage-restaurants.assigned-users', 'Assigned')}</p>
          <p>{store.assignedUsersCount}</p>
        </Typography>
      </div>
    </Card>
  );
};
